import { UserInfoAction, UserInfoActionTypes } from './user-info.actions';
import { UserProfile } from '../interfaces';

export const USERINFO_FEATURE_KEY = 'userInfo';

/**
 * Interface for the 'UserInfo' data used in
 *  - UserInfoState, and
 *  - userInfoReducer
 *
 *  Note: replace if already defined in another module
 */

export interface UserInfoState {
  userProfile?: UserProfile;
  loaded: boolean; // has the UserInfo list been loaded
}

export interface UserInfoPartialState {
  readonly [USERINFO_FEATURE_KEY]: UserInfoState;
}

export const initialState: UserInfoState = {
  loaded: false,
};

export function userInfoReducer(
  state: UserInfoState = initialState,
  action: UserInfoAction,
): UserInfoState {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (action.type) {
    case UserInfoActionTypes.UserInfoLoaded: {
      return {
        ...state,
        userProfile: action.payload,
        loaded: true,
      };
    }

    default:
      return state;
  }
}
